import { render, staticRenderFns } from "./promote-package-option.vue?vue&type=template&id=3af0b047"
import script from "./promote-package-option.vue?vue&type=script&lang=ts"
export * from "./promote-package-option.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports